// Note: removing Membership for MVP
//const coverageStepOptions = ['Membership', 'CoverageProtection', 'Payment']
const coverageStepOptions = ['CoverageProtection', 'Payment']

interface stateProp {
  showVehicle: boolean
  showProfile: boolean
  showUnderwriting: boolean
  showCoverage: boolean
  showCredit: boolean
  creditSectionFinished: boolean
  coverageStep: string
}

const initialState: stateProp = {
  showVehicle: true,
  showProfile: false,
  showUnderwriting: false,
  showCoverage: false,
  showCredit: false,
  creditSectionFinished: false,
  coverageStep: coverageStepOptions[0],
}

const applicationState = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_APPLICATION_STATE':
      return {
        ...state,
        ...action.payload,
      }

    case 'TOGGLE_VEHICLE_UI_STATE':
      return {
        ...state,
        showVehicle: !state.showVehicle,
        ...(state.showVehicle
          ? {}
          : {
              showProfile: false,
              showCoverage: false,
              showUnderwriting: false,
              showCredit: false,
            }),
      }

    case 'TOGGLE_PROFILE_UI_STATE':
      return {
        ...state,
        showProfile: !state.showProfile,
        ...(state.showProfile
          ? {}
          : {
              showVehicle: false,
              showCoverage: false,
              showUnderwriting: false,
              showCredit: false,
            }),
      }

    case 'TOGGLE_UNDERWRITING_UI_STATE':
      return {
        ...state,
        showUnderwriting: !state.showUnderwriting,
      }
    case 'TOGGLE_COVERAGE_UI_STATE':
      return {
        ...state,
        showCoverage: !state.showCoverage,
        ...(state.showCoverage
          ? {}
          : {
              showVehicle: false,
              showProfile: false,
              showUnderwriting: false,
              showCredit: false,
            }),
      }
    case 'TOGGLE_CREDIT_UI_STATE':
      return {
        ...state,
        showCredit: !state.showCredit,
      }
    case 'COVERAGE_DETAILS_NEXT_STEP':
      const currentStepNext = coverageStepOptions.indexOf(state.coverageStep)
      return {
        ...state,
        coverageStep: coverageStepOptions[currentStepNext + 1],
      }
    case 'COVERAGE_DETAILS_PREVIOUS_STEP':
      const currentStepPrev = coverageStepOptions.indexOf(state.coverageStep)
      return {
        ...state,
        coverageStep: coverageStepOptions[currentStepPrev - 1],
      }
    case 'RESET_REFI_APPLICATION_UI_STATE':
      return initialState
    case 'GO_TO_COVERAGE_DETAILS_SECTION':
      return {
        ...state,
        showProfile: false,
        showVehicle: false,
        showCredit: false,
        creditSectionFinished: true,
        showCoverage: true,
        //coverageStep: 'Membership', // Note: Membership disabled for MVP
        coverageStep: 'CoverageProtection',
      }
    case 'CREDIT_SECTION_FINISHED':
      return {
        ...state,
        creditSectionFinished: true,
      }
    case 'CREDIT_SECTION_NOT_FINISHED':
      return {
        ...state,
        creditSectionFinished: false,
      }
    default:
      return state
  }
}

export default applicationState

export const selectRefiAppVehicleUiState = (state) => {
  return state.refis.applicationState.showVehicle
}

export const selectRefiAppProfileUiState = (state) => {
  return state.refis.applicationState.showProfile
}

export const selectRefiAppUnderwritingUiState = (state) => {
  return state.refis.applicationState.showUnderwriting
}

export const selectRefiAppCoverageUiState = (state) => {
  return state.refis.applicationState.showCoverage
}

export const selectRefiAppPaymentUiState = (state) => {
  return state.refis.applicationState.showPaymentOptions
}

export const selectCoverageStepState = (state) => {
  return state.refis.applicationState.coverageStep
}

export const selectRefiAppCreditUiState = (state) => {
  return state.refis.applicationState.showCredit
}

export const selectCreditSessionFinished = (state) => {
  return state.refis.applicationState.creditSectionFinished
}
